import { t } from '@lingui/core/macro';

import Close from '@rover/icons/svg/close.svg';
import { Button, Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type ImageGridCloseButtonProps = {
  onClick: () => void;
};

const ImageGridCloseButton = ({ onClick }: ImageGridCloseButtonProps): JSX.Element => {
  const { colors } = useTheme();
  return (
    <Flex justifyContent="flex-end" flexDirection="row" width="100%">
      <Button
        variant="flat"
        icon={Close}
        onClick={onClick}
        aria-label={t`Dismiss`}
        sx={{
          color: colors.text.primary_inverse,
          '&:hover, &:focus': { color: colors.interactive_link.secondary_inverse_pressed },
        }}
        circular
        contrast
      />
    </Flex>
  );
};

export default ImageGridCloseButton;
